import React from 'react';

const SegmentedProgressBar = ({ value, label, totalSegments = 10, reverse = false, color = null }) => {
    // Value is a percentage (can be > 100)
    const percentage = Math.max(0, parseFloat(value) || 0);
    const isExceeded = percentage > 100;

    // Determine active segments (each segment represents 100/totalSegments %)
    const segmentSize = 100 / totalSegments;
    const activeSegments = Math.min(totalSegments, Math.ceil(percentage / segmentSize));

    // Color logic
    let activeColor = 'var(--primary-color)';
    if (percentage > 100) activeColor = 'var(--status-delayed)'; // Red
    else if (percentage > 90) activeColor = 'var(--status-loading)'; // Amber

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {label}
                </span>
                <span style={{ fontSize: '0.9rem', fontWeight: '800', color: isExceeded ? 'var(--status-delayed)' : 'var(--text-primary)' }}>
                    %{Math.round(percentage)}
                </span>
            </div>

            <div style={{
                display: 'flex',
                gap: '3px',
                width: '100%',
                height: '10px',
            }}>
                {[...Array(totalSegments)].map((_, i) => {
                    const isActive = reverse
                        ? i < Math.ceil((100 - Math.min(percentage, 100)) / segmentSize) // Countdown
                        : i < activeSegments; // Standard

                    return (
                        <div
                            key={i}
                            style={{
                                flex: 1,
                                borderRadius: '3px',
                                background: isActive ? (color || activeColor) : 'var(--bg-hover)',
                                border: `1px solid ${isActive ? 'transparent' : 'var(--border-color)'}`,
                                opacity: isActive ? 1 : 0.4,
                                transition: 'all 0.3s ease',
                                boxShadow: isActive ? `0 0 8px ${(color || activeColor)}80` : 'none'
                            }}
                        ></div>
                    );
                })}
            </div>
        </div>
    );
};

export default SegmentedProgressBar;
